import { useState, useEffect, useMemo } from "react";
import styled from "styled-components";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";
import GreenButton from "../../ui/GreenButton";
import * as XLSX from 'xlsx';

const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

`;
const ScrollableContainer = styled.div`
  width: 100%;
  max-height: 80vh; 
  overflow-y: auto;
`;

const Div2 = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;




const Tr = styled.tr`
  text-align: center;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
  }
`;


const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 8px 0;
    width: auto;
    &::before {
      content: attr(data-label);
      font-weight: bold;
      color: #333;
      margin-right: 10px;
    }
  }
`;


const Td3 = styled.td`
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin: 10px 0px;
  align-items: center;

  span{
    margin: 0px 5px;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; 
    text-align: center;
    gap: 15px;
  }

`;

const Input = styled.input`
  width: 500px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
`;

const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  justify-content:center;
  
  span{
    padding: 0px  10px;
  }
`;

const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const TableWrapper = styled.div`

  overflow: auto;
  border-radius: 7px;
  background: #fff;
  

  max-width: 98%;   /* limite de largura */
  margin: auto;   /* centraliza */
  padding: 12px;/* leve respiro interno */
`;

export const Table = styled.table`
 
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;

  /* (opcionais do seu layout externo) */
  box-shadow: 0 0 2px #ccc;
  border-radius: 7px;
  margin-bottom: 10px;

  /* células padrão */
  th, td {
    padding: 12px 14px;
    font-size: 14px;
    color: #333;
  }

  /* cabeçalho fixo */
  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fafafa;
    color: #555;
    font-weight: 600;
    text-align: left;
    border-bottom: 1px solid #eee;
  }

  /* listras + hover */
  tbody tr { transition: background 0.15s ease; }
  tbody tr:nth-child(even) { background: #fcfcfc; }
  tbody tr:hover { background: #E5F7EE; }

  /* divisórias e alinhamento */
  tbody td {
    border-bottom: 1px solid #f0f0f0;

  }
  tbody tr:last-child td { border-bottom: 0; }

  /* cantos arredondados */
  thead th:first-child { border-top-left-radius: 5px; }
  thead th:last-child  { border-top-right-radius: 5px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 5px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 5px; }

  /* descrição com quebra — sem mudar seu JSX (4ª coluna) */
  tbody td:nth-child(4) {
    max-width: 520px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  @media (max-width: 780px) {
    min-width: 600px; /* força scroll horizontal no mobile */
    th, td { padding: 10px 12px; font-size: 13px; }
  }
`;

const Grid = ({ showGrid2, listaSaldos }) => {





  //---------------------------------------FUNÇÂO DE PESQUISA---------------------------------------------------//

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(listaSaldos);
  const [isLoading, setIsLoading] = useState(true);






  //Input de pesquisa
  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const lowerTerm = term.toLowerCase();

      const filtered = listaSaldos.filter((item) => {
        // Campo de busca (texto livre)
        const data = (item.DATA_FORMATADA || '').toLowerCase();
        const codMaterial = (item.COD_MATERIAL || '').toString().toLowerCase();
        const descricao = (item.DESCRICAO || '').toLowerCase();


        const passaBusca =
          data.includes(lowerTerm) ||
          codMaterial.includes(lowerTerm) ||
          descricao.includes(lowerTerm);



        return (
          passaBusca
        );
      });

      setFilteredUsers(filtered);
      setCurrentPage(1);
    } catch (error) {
      console.error("Erro ao pesquisar:", error);
    } finally {
      setIsLoading(false);
    }
  };




  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, listaSaldos]);

  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };




  const exportarParaExcel = (dados, nomeArquivo = 'saldo_atual.xlsx') => {
    // Mapeia os dados para o Excel
    const dadosFormatados = dados.map(item => ({
      'Código': item.COD_MATERIAL,
      'Uni': item.UNIDADE_MEDIDA,
      'Descrição': item.DESCRICAO,
      'Tipo': item.DESC_TIPO,
      'SubTipo': item.DESC_SUBTIPO,
      'Saldo Atual': item.SALDO_ATUAL

    }));

    // Cria uma planilha
    const ws = XLSX.utils.json_to_sheet(dadosFormatados);

    // Cria um workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Saldo Atual');

    // Exporta
    XLSX.writeFile(wb, nomeArquivo);
  };



  return (


    <ScrollableContainer>
      <Container>

        {showGrid2 && (


          <>
            <Td3 >
              <Input
                type="text"
                placeholder="Pesquisar... Ex: código ou descrição"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              <Select value={itemsPerPage} onChange={(e) => {
                const value = e.target.value === "all" ? sortedData.length : parseInt(e.target.value);
                setItemsPerPage(value);
                setCurrentPage(1); // Resetar para a primeira página sempre que mudar
              }}>
                <option value={10}>10 por página</option>
                <option value={50}>50 por página</option>
                <option value={100}>100 por página</option>
                <option value="all">Todos</option>
              </Select>
              <Div>
                <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                  <ImArrowLeft size={20} />
                </Button>
                <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
                <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
                  <ImArrowRight size={20} />
                </Button>
              </Div>

              <Div2>
                <GreenButton onClick={() => exportarParaExcel(listaSaldos)}>
                  Exportar Excel
                </GreenButton>
              </Div2>



            </Td3>


            {currentItems.length === 0 ? (
              <Tr>
                <Td colSpan={4} style={{ textAlign: 'center', padding: '20px', fontSize: '18px' }}>
                  Não existem saldo para esse código ou período.
                </Td>
              </Tr>
            ) : (
              <TableWrapper>
                <Table>
                  <thead>
                    <tr>
                      <th onClick={() => onColumnClick("COD_MATERIAL")} className={getSortClass("COD_MATERIAL")}>
                        Código: {getSortIcon("COD_MATERIAL")}
                      </th>

                      <th onClick={() => onColumnClick("UNIDADE_MEDIDA")} className={getSortClass("UNIDADE_MEDIDA")}>
                        Uni: {getSortIcon("UNIDADE_MEDIDA")}
                      </th>

                      <th onClick={() => onColumnClick("DESCRICAO")} className={getSortClass("DESCRICAO")}>
                        Descrição: {getSortIcon("DESCRICAO")}
                      </th>

                      <th onClick={() => onColumnClick("DESC_TIPO")} className={getSortClass("DESC_TIPO")}>
                        Tipo: {getSortIcon("DESC_TIPO")}
                      </th>
                      <th onClick={() => onColumnClick("DESC_SUBTIPO")} className={getSortClass("DESC_SUBTIPO")}>
                        Subtipo: {getSortIcon("DESC_SUBTIPO")}
                      </th>

                      <th onClick={() => onColumnClick("SALDO_ATUAL")} className={getSortClass("SALDO_ATUAL")}>
                        Saldo Atual: {getSortIcon("SALDO_ATUAL")}
                      </th>


                    </tr>
                  </thead>

                  <tbody>
                    {currentItems.map((item, i) => (
                      <tr key={i}>
                        <td>{item.COD_MATERIAL}</td>
                        <td>{item.UNIDADE_MEDIDA}</td>
                        <td>{item.DESCRICAO}</td>
                        <td>{item.DESC_TIPO}</td>
                        <td>{item.DESC_SUBTIPO}</td>
                        <td>{item.SALDO_ATUAL}</td>

                      </tr>
                    ))}
                  </tbody>
                </Table>
              </TableWrapper>

            )}

          </>
        )}

      </Container>
    </ScrollableContainer>
  );
};


export default Grid;
